<template>
  <v-sheet class="mt-5 pa-5" tile>
    <v-container>
      <v-card class="mx-auto" height="300px" width="150px">
        <v-subheader>{{ $t('ITEM.NOTES') }}</v-subheader>
      </v-card>
    </v-container>
  </v-sheet>
</template>

<script>
export default {
  name: 'NotesCard'
};
</script>

<style scoped>
* {
  text-transform: none !important;
}
</style>
